type Listener = (data: any) => void;

/**
 * 进程内广播总线：替代 PC 的 electronAPI.broadcastControl / onBroadcastControlMessage。
 * 网页端所有 FeaturedInteractionHandler 实例共享一个 EventBus，master 的交互消息经此分发到从机。
 * 载荷结构与 PC IPC 保持一致：{ sourcePhoneId, groupId, message, timestamp }。
 */
export class BroadcastBus {
    private static instance: BroadcastBus;
    private listeners: Set<Listener> = new Set();

    static getInstance(): BroadcastBus {
        if (!BroadcastBus.instance) {
            BroadcastBus.instance = new BroadcastBus();
        }
        return BroadcastBus.instance;
    }

    emit(payload: { sourcePhoneId: string; groupId: string; message: any; timestamp: number }): void {
        this.listeners.forEach((listener) => {
            try {
                listener(payload);
            } catch (error) {
                console.error('[BroadcastBus] listener error', error);
            }
        });
    }

    on(listener: Listener): () => void {
        this.listeners.add(listener);
        return () => this.off(listener);
    }

    off(listener: Listener): void {
        this.listeners.delete(listener);
    }

    clear(): void {
        this.listeners.clear();
    }

    listenerCount(): number {
        return this.listeners.size;
    }
}
